<template>
    <div class="container">
        <div class="nav_wrapper second_font">
            <ul>
                <li @click="onTagClick(null)">
                    <a :class="{ active: isActive(null) }" href="#">
                        הצג הכל
                    </a>
                </li>
                <li v-for="tag in tags" :key="tag.id" @click="onTagClick(tag)">
                    <a href="#" :class="{ active: isActive(tag) }">
                        {{ tag.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            required: true
        },
        selected: {
            type: Object,
            required: false,
            default: null
        }
    },

    methods: {
        onTagClick(tag) {
            this.$emit('tag-clicked', tag);
        },

        isActive(tag) {
            if (!this.selected) {
                return !tag;
            }

            if (!tag) {
                return false;
            }

            return tag.id === this.selected.id;
        }
    }
};
</script>
